import React from 'react'

const Header = ({ onSortChange, sort, sortOrder, editMode }) => (
    <thead>
        <tr className="audience-list audience-list--header">
            {/* 
            <th className="audience-list audience-list--audience pointer" style={{ width: '40%' }} >
                Partner ID
                {sort === 'partnerId' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            */}
            <th className="audience-list audience-list--audience pointer" style={{ width: '10%' }} >
                Marketplace
                {sort === 'dmp' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            <th className="audience-list audience-list--audience pointer" style={{ width: '20%' }} >
                Product
                {sort === 'product' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            <th className="audience-list audience-list--size pointer" style={{ width: '5%' }} >
                Revenue Share %{sort === 'revShare' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            <th className="audience-list audience-list--size pointer" style={{ width: '10%' }} >
                Min CPM Price {sort === 'minPrice' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>

            {editMode && (
                <th style={{ width: '5%' }} className="audience-list audience-list--edit">
                    Edit
                </th>
            )}
        </tr>
    </thead>
)

export default Header
